/**
 * Hook to check if the AI voice assistant is globally enabled.
 * Reads from Firestore system_config/voiceAssistant. Returns `false` by default
 * (HIDDEN) until an admin explicitly enables it from the admin panel.
 */
'use client';
import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase/client';

export function useVoiceAssistantEnabled(): { enabled: boolean; loading: boolean } {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'system_config', 'voiceAssistant'));
        if (mounted && snap.exists()) {
          setEnabled(snap.data()?.enabled === true);
        }
      } catch {
        // Default to hidden on error
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);
  return { enabled, loading };
}
